import * as types from './types';

const mutations = {
  [types.SET_ACCOUNT]: (state, payload) => {
    const {
      id, companyName, email, firstName, lastName, features, advertisers, properties,
    } = payload;
    state.id = id;
    state.companyName = companyName;
    state.email = email;
    state.firstName = firstName;
    state.lastName = lastName;
    state.avatarColour = properties?.avatarColour;

    if (features) state.features = features;
    if (!features || !features.includes('MANAGED_CAMPAIGNS')) {
      state.advertiserId = advertisers.length > 0 ? advertisers[0].id : null;
    }
  },
  [types.SET_INVOICING_ID]: (state, payload) => {
    state.invoicingId = payload;
  },
  [types.SET_INVOICING_DETAILS]: (state, payload) => {
    const {
      id,
      addressLine1,
      addressLine2,
      townCity,
      postcode,
      countryId,
      companyRegistrationNumber,
      contactName,
      contactEmail,
    } = payload;
    state.invoicingId = id;
    state.addressLine1 = addressLine1;
    state.addressLine2 = addressLine2;
    state.townCity = townCity;
    state.postcode = postcode;
    state.countryId = countryId;
    state.companyRegistrationNumber = companyRegistrationNumber;
    state.contactName = contactName;
    state.contactEmail = contactEmail;
    state.jobTitle = 'test';
  },
  [types.RESET_INVOICING_DETAILS]: (state) => {
    state.addressLine1 = null;
    state.addressLine2 = null;
    state.townCity = null;
    state.postcode = null;
    state.countryId = null;
    state.companyRegistrationNumber = null;
    state.contactName = null;
    state.contactEmail = null;
    state.invoicingId = null;
  },
  [types.RESET_ACCOUNT]: (state) => {
    state.id = null;
    state.companyName = null;
    state.email = null;
    state.firstName = null;
    state.lastName = null;
    state.addressLine1 = null;
    state.addressLine2 = null;
    state.townCity = null;
    state.postcode = null;
    state.countryId = null;
    state.companyRegistrationNumber = null;
    state.contactName = null;
    state.contactEmail = null;
    state.invoicingId = null;
    state.features = null;
    state.advertiserId = null;
  },
  [types.SET_SHAREES_COUNT]: (state, payload) => {
    state.shareeCount = payload;
  },
  [types.SET_AVATAR_COLOUR]: (state, payload) => {
    const {
      properties,
    } = payload;
    state.avatarColour = properties?.avatarColour;
  },
};

export default mutations;
